import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * New navigation (PUSH/REPLACE): jump to top before first paint.
 * Back/forward (POP): leave it to the browser's native scroll restoration.
 * Hash links are handled by the destination page.
 */
export default function ScrollReset() {
  const { pathname, search, hash } = useLocation();
  const navType = useNavigationType();
  useLayoutEffect(() => {
    if (hash || navType === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search, hash, navType]);
  return null;
}